module.exports = __webpack_public_path__ + "media/images/pendleton_logo-7e825e1a62887e4037f2b18c749762c2.png";